import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export default makeStyles((theme: MuiTheme) => ({
  dialogRoot: {
    width: "100%",
    marginTop: 64,
    marginLeft: 220,
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      marginLeft: 84
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      marginTop: 0,
      marginLeft: 0
    },
    "& .MuiBackdrop-root": {
      top: 64,
      left: 220,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        left: 84
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        left: 0
      }
    },
    "& MuiDialog-container": {
      width: "100%",
      height: "100%"
    },
    "& .MuiDialog-scrollPaper": {
      alignItems: "normal",
      justifyContent: "normal",
      borderLeft: `1px solid ${theme.palette.text.hint}`
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "calc(100% - 220px)",
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        maxWidth: "calc(100% - 84px)"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        maxWidth: "100%"
      }
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "100%"
    },
    "& .MuiPaper-elevation24": {
      boxShadow: "none"
    },
    "& .MuiPaper-rounded": {
      borderRadius: 0
    },
    "& .MuiPaper-root": {
      margin: 0,
      width: "100%",
      height: "100%"
    }
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    padding: 0,
    height: 55,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      borderBottom: "none"
    }
  },
  dialogTitleHeader: {
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontWeight: 600
  },
  closeButton: {
    position: "absolute",
    padding: 8,
    right: 6,
    top: 8
  },
  dialogContent: {
    padding: "24px 20px",
    position: "relative",
    display: "grid",
    justifyContent: "center",
    alignItems: "flex-start",
    flex: "auto",
    gridTemplateColumns: "238px minmax(auto, 410px)",
    gridGap: 20,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
      gridGap: 0
    }
  },
  leftContentWrapper: {
    width: 238,
    position: "relative"
  },
  leftContent: {
    width: 238,
    border: `1px solid ${theme.palette.text.hint}`,
    position: "fixed"
  },
  dialogButtons: {
    display: "flex",
    width: "100%",
    padding: 0,
    minHeight: 50,
    borderTop: `1px solid ${theme.palette.text.hint}`
  },
  closeActionButton: {
    color: "#998765",
    "& .MuiButton-startIcon": {
      marginRight: 4
    }
  },
  completeActionButton: {
    color: theme.palette.secondary.dark,
    borderColor: theme.palette.secondary.dark,
    "& .MuiButton-iconSizeMedium > *:first-child": {
      fontSize: 14,
      marginTop: 1
    }
  },
  reopenActionButton: {
    color: "#998765",
    backgroundColor: theme.palette.common.white
  },
  undoActionButton: {
    color: "#d92e44",
    "& .MuiButton-startIcon": {
      transform: "scaleX(-1)"
    }
  },
  actionButton: {
    textTransform: "capitalize",
    borderRadius: 0,
    lineHeight: "50px",
    padding: 0,
    fontFamily: "SuisseIntlRegular",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      margin: 16,
      borderRadius: 3,
      borderStyle: "solid",
      borderWidth: 1,
      textTransform: "uppercase",
      fontSize: 16,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "47px"
    },
    "& .MuiButton-iconSizeMedium > *:first-child": {
      fontSize: 17,
      position: "relative",
      bottom: 1
    },
    "&:not(:first-child)": {
      margin: 0,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: 16,
        marginLeft: 0
      },
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        borderLeft: `1px solid ${theme.palette.text.hint}`
      }
    }
  },
  assignButton: {
    color: "#4269B5",
    height: 32,
    padding: 8,
    marginRight: -8,
    width: "auto",
    borderColor: "rgba(66, 105, 181, 1)",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      border: "none",
      textTransform: "none",
      fontSize: 14,
      fontFamily: "SuisseIntlRegular"
    }
  },
  actionButtonActive: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.common.white,
    "&$closeActionButton": {
      backgroundColor: "#998765"
    },
    "&$completeActionButton": {
      backgroundColor: theme.palette.secondary.dark
    },
    "&$reopenActionButton": {
      backgroundColor: "#998765"
    },
    "&$undoActionButton": {
      backgroundColor: "#d92e44"
    }
  },
  activeCompleteButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "&.MuiButton-root:hover": {
      backgroundColor: "inherit"
    }
  },
  rightContent: {
    maxWidth: 410,
    border: `1px solid ${theme.palette.text.hint}`,
    flex: "auto",
    maxHeight: "calc(100dvh - 167px)",
    overflowY: "auto"
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 50,
    "&:nth-child(2n)": {
      background: "rgba(238, 238, 238, 0.5)"
    }
  },
  text: {
    border: "none",
    color: theme.palette.text.secondary,
    fontSize: 12,
    padding: "0 13px"
  },
  rightColumnText: {
    display: "flex",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
    flexDirection: "row",
    alignItems: "center",
    "&.inactive": {
      color: theme.palette.text.secondary
    }
  },
  reporterInfo: {
    position: "relative",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    padding: "5px 16px 10px"
  },
  rightContentHeader: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    lineHeight: "normal",
    padding: "8px 0",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  reporterName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 14,
    textTransform: "capitalize",
    color: theme.palette.text.primary,
    lineHeight: "20px",
    marginBottom: 4
  },
  reporterContacts: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  icon: {
    width: 14,
    marginRight: 11
  },
  contactsText: {
    color: "#333333",
    fontSize: 12
  },
  orderStatus: {
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    height: 28,
    fontSize: 14,
    textTransform: "uppercase",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "flex"
    }
  },
  [racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_OPEN]: {
    color: "rgba(244, 120, 68, 1)",
    backgroundColor: "rgba(244, 120, 68, 0.1)"
  },
  [racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_ASSIGNED]: {
    color: "rgba(66, 105, 181, 1)",
    backgroundColor: "rgba(66, 105, 181, 0.1)"
  },
  [racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED]: {
    color: "rgba(244, 120, 68, 1)",
    backgroundColor: "rgba(244, 120, 68, 0.1)"
  },
  [racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED]: {
    color: "rgba(153, 135, 101, 1)",
    backgroundColor: "rgba(153,135,101,0.1)"
  },
  [racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE]: {
    color: "rgba(97, 198, 158, 1)",
    backgroundColor: "rgba(97,198,158,0.1)"
  },
  orderDescription: {
    borderBottom: `1px solid ${theme.palette.text.hint}`
  },
  descriptionWrap: {
    padding: "5px 18px 19px 16px"
  },
  tableContentText: {
    textTransform: "capitalize",
    textAlign: "center",
    color: theme.palette.text.primary,
    lineHeight: "20px",
    "&:first-child": {
      textAlign: "left"
    }
  },
  tableCell: {
    padding: 0
  },
  orderType: {
    marginTop: 10
  },
  description: {
    marginTop: 10
  },
  descriptionText: {
    wordBreak: "break-word",
    color: theme.palette.text.primary,
    fontSize: 12,
    lineHeight: "17px"
  },
  notes: {
    display: "flex",
    padding: "8px 16px",
    flexDirection: "column"
  },
  popover: {
    "& .MuiPaper-root": {
      marginLeft: 8,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        marginLeft: 32
      }
    }
  },
  reassignButton: {
    color: "rgba(66, 105, 181, 1)",
    padding: 4,
    marginTop: -2,
    marginRight: -4,
    marginLeft: 2
  },
  reassignButtonIcon: {
    fontSize: 15
  },
  swipeableTabsRoot: {
    flex: "auto",
    width: "100%",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      overflow: "auto"
    }
  },
  swipeableTabsContent: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      position: "sticky",
      top: 0,
      backgroundColor: theme.palette.common.white,
      zIndex: 1
    }
  },
  leftAligning: {
    textAlign: "left"
  },
  assignToBlock: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 50,
    padding: "0 16px",
    borderBottom: `1px solid ${theme.palette.text.hint}`
  },
  editButton: {
    position: "absolute",
    minWidth: 54,
    top: 10,
    right: 4,
    padding: 0,
    color: "#333333"
  },
  editButtonLabel: {
    fontSize: 12,
    textTransform: "none",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  editButtonStartIcon: {
    marginRight: 4,
    "& .MuiSvgIcon-root": {
      fontSize: 13
    }
  }
}));
